<template>
  <span>
    Has Blood Transfusion
  </span>
</template>
<script>

export default {
  name: 'HasBloodTransfusion',

  props: {
    field: {
      type: Object,
      required: true,
    },
    condition: {
      type: Object,
      required: true,
    },
  },
};
</script>
